// extracted by mini-css-extract-plugin
export var avatarContainer = "_9z-0";
export var avatarTypingWave = "_9z-i";
export var gray = "_9z-f";
export var green = "_9z-c";
export var icon = "_9z-9";
export var image = "_9z-1";
export var lg = "_9z-6";
export var md = "_9z-5";
export var presenceDot = "_9z-b";
export var red = "_9z-d";
export var sm = "_9z-4";
export var status = "_9z-a";
export var typingDot = "_9z-h";
export var typingPill = "_9z-g";
export var xl = "_9z-7";
export var xs = "_9z-3";
export var xxl = "_9z-8";
export var xxs = "_9z-2";
export var yellow = "_9z-e";